import { ENV_CONFIG } from './environment';

// API Configuration
export const API_CONFIG = {
  BASE_URL: ENV_CONFIG.API_URL,
  ENDPOINTS: {
    // Admin Auth
    ADMIN_LOGIN: '/admin/auth/login',
    ADMIN_PROFILE: '/admin/auth/profile',
    ADMIN_LOGOUT: '/admin/auth/logout',
    ADMIN_CHANGE_PASSWORD: '/admin/auth/change-password',
    
    // Admin Categories
    ADMIN_CATEGORIES: '/admin/categories',
    ADMIN_CATEGORY_BY_ID: (id: number) => `/admin/categories/${id}`,
    ADMIN_CATEGORY_STATUS: (id: number) => `/admin/categories/${id}/status`,
    ADMIN_CATEGORIES_BULK: '/admin/categories/bulk',
    
    // Admin Doctors
    ADMIN_DOCTORS: '/admin/doctors',
    ADMIN_DOCTOR_BY_ID: (id: number) => `/admin/doctors/${id}`,
    ADMIN_DOCTOR_STATUS: (id: number) => `/admin/doctors/${id}/status`,
    ADMIN_DOCTORS_BULK: '/admin/doctors/bulk',
    
    // Admin Patients
    ADMIN_PATIENTS: '/admin/patients',
    ADMIN_PATIENT_BY_ID: (id: number) => `/admin/patients/${id}`,
    ADMIN_PATIENT_STATUS: (id: number) => `/admin/patients/${id}/status`,
    ADMIN_PATIENTS_BULK: '/admin/patients/bulk',
    
    // Admin Banners (for future use)
    ADMIN_BANNERS: '/admin/banners',
    ADMIN_BANNER_BY_ID: (id: number) => `/admin/banners/${id}`,
    
    // Admin Withdrawals
    ADMIN_WITHDRAWALS: '/admin/withdrawals',
    ADMIN_WITHDRAWAL_BY_ID: (id: number) => `/admin/withdrawals/${id}`,
    ADMIN_WITHDRAWAL_APPROVE: (id: number) => `/admin/withdrawals/${id}/approve`,
    ADMIN_WITHDRAWAL_REJECT: (id: number) => `/admin/withdrawals/${id}/reject`,
    
    // Admin Dashboard
    ADMIN_DASHBOARD_STATS: '/admin/dashboard/stats',
  },
  TIMEOUT: 10000, // 10 seconds
  RETRY_ATTEMPTS: 3,
};

// Helper function to get full API URL
export const getApiUrl = (endpoint: string): string => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};

// Helper function to get auth headers
export const getAuthHeaders = (isFormData: boolean = false) => {
  const token = localStorage.getItem('admin_token');
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': isFormData ? 'multipart/form-data' : 'application/json',
    'Accept': 'application/json',
  };
};

// Helper function to handle API responses
export const handleApiResponse = async (response: Response) => {
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
  }
  return response.json();
};
